import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type EmailConfirmationMessages = SidebarMessages & {
  confirmEmailTitle: string;
  emailConfirmationIllustration: string;
};
export const EMAIL_CONFIRMATION_MESSAGES: EmailConfirmationMessages = {
  confirmEmailTitle: "Confirmando o email...",
  emailConfirmationIllustration: "Email confirmation Illustration",
  // SIDEBAR
  ...SIDEBAR_MESSAGES,
};

export default EMAIL_CONFIRMATION_MESSAGES;
